import is from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'

const Message = styled.span<IMessageProps>`
  font-size: ${({ size }) => (size ? 11 * size : 11)}px;
  ${is('warning')`
    color: ${({ theme }: ITheme) => theme.colors.palette.tangerine};
  `}
  ${is('error')`
    color: ${({ theme }: ITheme) => theme.colors.palette.reddish};
  `}
`

export default Message

export interface IMessageProps {
  warning?: boolean
  error?: boolean
  size?: number
}
